import { checkIfDateEqual, isISOString } from './date';

const checkIfClaimDateIsToday = (localStorageKey: string): boolean => {
  const lastClaimDate = localStorage.getItem(localStorageKey);

  if (!lastClaimDate) {
    return false;
  }

  const storageValueIsISOString = isISOString(lastClaimDate);

  if (!storageValueIsISOString) {
    return false;
  }

  return checkIfDateEqual(new Date(), new Date(lastClaimDate));
};

export { checkIfClaimDateIsToday };
